export const SCRoutes = {
  resetPassword: '/reset/password/:token',
  signup: '/signup',
};
